import Vue from 'vue';
import request from '../../../utils/request';
import menuReturn from '../../../components/console-common/menu-return.vue';
import { toFen, toYuan } from '../../../utils/unit-conversion';
export default Vue.extend({
    name: 'balanceSure',
    components: {
        'el-menu-return': menuReturn,
    },
    data: function () {
        var _this = this;
        var checkCash = function (rule, value, callback) {
            _this.isShowCash = true;
            _this.isDisableSubmit = true;
            if (value === '') {
                _this.isShowCash = false;
                callback(new Error('请输入数字'));
                return;
            }
            var reg = /^[0-9]+(\.[0-9]{1,2})?$/;
            if (!reg.test(value)) {
                _this.isShowCash = false;
                callback(new Error('数字最多6位整数，2位小数'));
                return;
            }
            if (value > _this.ableCount) {
                _this.isShowCash = false;
                callback(new Error("\u63D0\u73B0\u91D1\u989D\u4E0D\u80FD\u8D85\u8FC7" + _this.ableCount + "\u5143,\u8BF7\u91CD\u65B0\u8F93\u5165"));
                return;
            }
            if (value <= 0) {
                _this.isShowCash = false;
                callback(new Error("\u63D0\u73B0\u91D1\u989D\u9700\u5927\u4E8E0"));
                return;
            }
            _this.isDisableSubmit = false;
        };
        return {
            bankName: '',
            tailNo: '',
            cardNoCode: '',
            bankLogo: '',
            ableCount: 0,
            isShowCash: false,
            titleConfig: {
                backTitle: '返回余额',
                currentTitle: '发起提现',
                routerName: true,
                name: 'fundBalance',
            },
            callCash: {
                cash: '',
                selectCard: 'default',
            },
            rules: {
                cash: [{ validator: checkCash, trigger: 'change' }],
            },
            isDisableSubmit: true,
            submitStatus: 'success',
        };
    },
    created: function () {
        this.callCash.cash = this.$route.params.cash; // ？ 能不能直接用计算属性赋值
    },
    mounted: function () {
        this.callCash.cash !== undefined
            ? ((this.isShowCash = true), (this.isDisableSubmit = false))
            : ((this.isShowCash = false), (this.isDisableSubmit = true));
        this.getBalance(); // 初始化可提现余额
        this.getBankCard(); // 获取银行卡
    },
    methods: {
        // 全部提现
        fullCash: function () {
            this.callCash.cash = this.ableCount;
        },
        // 获取可提现余额
        getBalance: function () {
            var _this = this;
            request({
                method: 'post',
                url: '/proxy/api/account/balance',
            }).then(function (res) {
                if (!res || res.errorCode !== 0) {
                    _this.$message.error("" + (res.errorMsg ? res.errorMsg : '获取可提现金额失败'));
                    return;
                }
                var data = res.data;
                _this.ableCount = toYuan(data.draw);
            });
        },
        // 获取银行卡
        getBankCard: function () {
            var _this = this;
            request({
                method: 'post',
                url: '/proxy/api/account/bankCards',
            }).then(function (res) {
                if (!res || res.errorCode !== 0) {
                    _this.$message.error("" + (res.errorMsg ? res.errorMsg : '获取银行卡信息失败'));
                    return;
                }
                var data = res.data.list[0];
                _this.bankName = data.bankName;
                _this.tailNo = data.tailNo;
                _this.cardNoCode = data.cardNoCode;
                _this.bankLogo = data.bankLogo;
            });
        },
        // 提交提现
        submitSure: function () {
            var _this = this;
            // if (!this.bankName && !this.tailNo) {
            //   this.$message.error('请选择银行卡')
            //   return
            // }
            var cash = this.callCash.cash;
            this.$confirm('', '', {
                message: "<p class=\"title\">\u63D0\u73B0\u786E\u8BA4</p>\n        <p class=\"text\">\u53D1\u8D77\u63D0\u73B0\u91D1\u989D" + cash + "\u5143,\n        \u5230\u8D26\u91D1\u989D" + cash + "\u5143,\u786E\u8BA4\u53D1\u8D77\u63D0\u73B0\u5417?</p>",
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showClose: false,
                type: 'warning',
            })
                .then(function () {
                _this.sureWithdraw();
            })
                .catch(function () { });
        },
        sureWithdraw: function () {
            var _this = this;
            request({
                method: 'post',
                url: '/proxy/api/account/withdraw',
                data: {
                    amount: toFen(this.callCash.cash),
                    cardNoCode: this.cardNoCode,
                    available: toFen(this.ableCount),
                },
            }).then(function (res) {
                if (!res || res.errorCode !== 0) {
                    _this.$router.push({
                        name: 'fundBalanceFail',
                        params: {
                            cash: _this.callCash.cash,
                            errorMsg: res && res.errorMsg
                                ? res.errorMsg
                                : '请您核对您的账户信息后重试',
                        },
                    });
                    return;
                }
                var data = res.data;
                _this.$router.push({
                    name: 'fundBalanceResult',
                    params: {
                        amount: data.amount,
                        actualAmount: data.actualAmount,
                        bankName: data.bankName,
                        cardTailNo: data.cardTailNo,
                    },
                });
            });
        },
        changeFen: function (val) {
            return toFen(val);
        },
        changeYuan: function (val) {
            return toYuan(val);
        },
    },
});
